import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/studioInfoSagas";

export const UpdateBtns = ({ resetData }) => {
  const dispatch = useDispatch();

  const filtersDirty = useSelector((state) => state.studioInfo.filtersDirty);

  return filtersDirty ? (
    <>
      <button className="submit" onClick={() => dispatch(actionCreators.updateAllData())}>
        Update
      </button>
      <button className="submit reset" onClick={resetData}>
        Reset
      </button>
    </>
  ) : null;
};
